import React from "react";
import {
  StyledMenu,
  MenuAside,
  LinkButton,
  ButtonBox,
  Title,
  FadedAside,
  Close,
  CloseBox,
} from "./styles";
import close from "../../assets/close.svg";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";

export const Menu = ({
  toggleForm,
  menuToggle,
  handleScroll,
  handleMenuToggle,
  handleMenuNav,
}) => (
  <StyledMenu id="menu" menuToggle={menuToggle}>
    <FadedAside onClick={() => handleMenuToggle(menuToggle)}>
      <CloseBox>
        <Close src={close} alt="close" />
      </CloseBox>
    </FadedAside>
    <MenuAside>
      <LinkButton
        as="a"
        href="https://www.instagram.com/explore/tags/mytruehome/?hl=en"
        target="_blank"
        onClick={() => handleMenuToggle(menuToggle)}
      > 
      <div className="mobile-AccessibilityMenu-show">
      <UserWayAccessibilityMenu color="black" width={40} height={40}/>
    </div>
        <ButtonBox>
          <Title id="menuStories">Your Stories</Title>
        </ButtonBox>
      </LinkButton>
      <ButtonBox onClick={() => handleScroll("taca")}>
        <Title id="menuTaca">About TACA</Title>
      </ButtonBox>
      <ButtonBox  onClick={() => handleScroll("swmc")}>
        <Title id='menuSwmc'>About Sun West</Title>
      </ButtonBox>
      <ButtonBox onClick={toggleForm}>
        <Title>Contact Us</Title>
      </ButtonBox>
      <ButtonBox
        onClick={() => handleMenuNav("/mytruehome/contest-rules", menuToggle)}
      >
        <Title id="menuContest">Contest Rules</Title>
      </ButtonBox>
    </MenuAside>
  </StyledMenu>
);
